module.exports = __webpack_public_path__ + "img/stilt_logo.f9ecbe09.svg";